import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
let addressInput = class addressInput extends Vue {
  constructor() {
    super(...arguments);
    this.answer1 = "";
    this.answer2 = "";
  }
  // eslint-disable-next-line
  watchIndex() {}
  dataChage(value) {
    // console.log("item---", value);
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        let answer1 = "";
        value.answer.answerList.forEach(as => {
          answer1 += as.name;
        });
        this.answer1 = answer1;
        this.answer2 = value.answer2;
      }
    }
  }
};
__decorate([Prop({
  type: String,
  default: "EDIT"
})], addressInput.prototype, "viewMode", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], addressInput.prototype, "zIndex", void 0);
__decorate([Watch("zIndex", {
  immediate: true
})], addressInput.prototype, "watchIndex", null);
__decorate([Prop({
  type: Object,
  default: {}
})], addressInput.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], addressInput.prototype, "dataChage", null);
addressInput = __decorate([Component({
  name: "addressInput"
})], addressInput);
export default addressInput;